import { useRef } from "react";

export function usePortal(portalId: string) {
  const ref = useRef<HTMLDivElement | null>();

  if (!ref.current) {
    // Try to get the portal from the DOM.
    const existingPortal = document.getElementById(portalId);
    if (existingPortal) {
      ref.current = existingPortal as HTMLDivElement;
    } else {
      // If not, create it and append it to the body.
      const div = document.createElement("div");
      div.id = portalId;
      document.body.appendChild(div);
      ref.current = div;
    }
  }
  return ref.current;
}
